/**
 * LC-2126: Fixed list of reasons a DAC admin must choose from when revoking a user's DUC access.
 * The selected reason is sent to the backend, persisted, and included in the revocation email.
 */
export const revocationReasons = [
    "Requestor's institution is located in a country of concern. See NIH Notice: NOT-OD-25-083: Implementation Update: Enhancing Security Measures for NIH Controlled-Access Data",
    "Email address is not affiliated with requestor's institution",
    "Requestor's email is in the public domain (e.g., Yahoo, Gmail)",
    "Requestor is a trainee (if applying for an individual-level DUC)",
    "Requestors are from different institutions (group-level DUC)",
    "Signing Official is not affiliated with requestor's institution",
    "Signing Official is also a requestor on the DUC",
    "Data use statement doesn't include information about which data structures (e.g., name of assessment(s) from ABCD or HBCD) requestor plans to access",
    "Data use statement includes request for data structures that are not available",
    "Data use statement and/or project report does not describe how data will be managed, and/or doesn't include plan for deletion if data have been downloaded",
    "Project report statement is missing or incomplete (for renewal requests only)",
    "Responsible data use violations (renewal)"
];
